import { useEffect, useState } from 'react';
import { Container, Segment, Header, Image, Grid, List, Divider, Card, Confirm, Button } from 'semantic-ui-react'
import { ROUTE_ALERT_APP_URL } from '../../app/common/data/constants';
import Footer from '../../app/layout/Footer';
import { useStore } from '../../app/stores/store';
import HomeNavBar from './HomeNavBar';
import HomeSideBar from './HomeSideBar';
import { observer } from 'mobx-react-lite';
import LoginForm from '../user/LoginForm';
import { router } from '../../app/router/Routes';

export default observer(function HomePage() {
    const token = window.localStorage.getItem('jwt');
    const {userStore, modalStore: { openModal }} = useStore();
    const {isLoggedIn, user} = userStore;
    const [openConfirm, setOpenConfirm] = useState(false);
    
    useEffect(() => {
        if(isLoggedIn && user && token) {
            router.navigate(`${process.env.PUBLIC_URL}/permits`);
        }
    }, [isLoggedIn, user, token])

    function handleCancelButton() {
        setOpenConfirm(false);
    }
    function handleOKButton() {
        setOpenConfirm(false);
        window.location.href = ROUTE_ALERT_APP_URL;
    }

    return (
        <>
            <HomeNavBar />
            <Container fluid className='home-top'>
                <Image src={`./assets/home-slider-image.jpg`} fluid/>
            </Container>
            <Container className='home-content'>
                <Segment basic>
                    <Grid>                    
                        <Grid.Column computer={12} tablet={12} mobile={16}>
                            <Container>
                                <Confirm
                                    open={openConfirm}
                                    header='Redirecting'
                                    content='You are about to redirect to Ferry Alerts. Would you like to proceed?'
                                    cancelButton='Cancel'
                                    confirmButton="Yes"
                                    onCancel={handleCancelButton}
                                    onConfirm={handleOKButton}
                                />
                                <Card.Group itemsPerRow={3} stackable doubling>
                                    <Card
                                        raised
                                        target='_blank'
                                        onClick={() => setOpenConfirm(true)}
                                        style={{background: '#007b5f', color: 'white'}}
                                    >
                                        <Card.Content>
                                            <Card.Header 
                                                style={{color: 'white'}}
                                            >Sign Up Ferry Alerts</Card.Header>
                                            <Card.Description 
                                                style={{color: 'white'}}
                                            >
                                            Receive bulletins/alerts via Email or SMS.
                                            </Card.Description>
                                        </Card.Content>
                                    </Card>
                                    <Card
                                        onClick={() => openModal(<LoginForm />)}
                                        style={{background: '#007b5f', color: 'white'}}
                                    >
                                        <Card.Content>
                                            <Card.Header 
                                                style={{color: 'white'}}
                                            >Carpool Permit</Card.Header>
                                            <Card.Description 
                                                style={{color: 'white'}}
                                            >
                                            Buy a Carpool Permit.
                                            </Card.Description>
                                        </Card.Content>
                                    </Card>
                                    <Card
                                        onClick={() => openModal(<LoginForm />)}
                                        style={{background: '#007b5f', color: 'white'}}
                                    >
                                        <Card.Content>
                                            <Card.Header 
                                                style={{color: 'white'}}
                                            >Vanpool Permit</Card.Header>
                                            <Card.Description 
                                                style={{color: 'white'}}
                                            >
                                            Buy a Vanpool Permit.
                                            </Card.Description>
                                        </Card.Content>
                                    </Card>
                                </Card.Group>
                                <Divider hidden />

                                <Header as='h1' className='home-h1' content={'carpool and vanpool permits'} />
                                <Header as='h3' className='home-h3' content={'guaranteed ride home/work'} />
                                <p className='home-text'>
                                Instead of spending time in a car alone driving to and from work every day, consider sharing the commute and enjoy the ride! When you find others with similar commutes and all go together, everyone benefits:
                                </p>

                                <Header as='h3' className='home-h3' content={'carpool/vanpool permit benefits'} />
                                <List bulleted>
                                    <List.Item>Reduced wear and tear on personal vehicles</List.Item>
                                    <List.Item>Shared driving responsibilities</List.Item>
                                    <List.Item>Less money spent on gas and maintenance</List.Item>
                                    <List.Item>Time to sit back and relax before and after work</List.Item>
                                    <List.Item>Fewer vehicles on the road mean fewer carbon emissions with less traffic and congestion</List.Item>
                                </List>
                                
                                <Header as='h3' className='home-h3' content={'carpool permit requirements'} />
                                <List bulleted>
                                    <List.Item>Commute with at least two other people (three riders total).</List.Item>
                                    <List.Item>You can form your own carpool, or visit <a href='http://rideshareonline.com' target='_blank' rel='noreferrer' title='View Rideshare Online'>Rideshare Online</a> to find potential partners.</List.Item>
                                    <List.Item>
                                        <Button basic className='button-link-text' 
                                            onClick={() => openModal(<LoginForm />)}
                                        >
                                            Register as a carpool
                                        </Button>
                                    </List.Item>
                                    <List.Item>Use your Carpool at least three days a week for a minimum of nine months.</List.Item>
                                    <List.Item>Carpool participants may only be registered in one carpool group. If the group travels in different vehicles, the permit may be transferred to another vehicle listed on your permit registration as long as the carpool placard is displayed in the front left windshield and the vehicle carries the appropriate number of riders.</List.Item>
                                    <List.Item>Pay $20 annually for the permit.</List.Item>
                                </List>
                                
                                <Header as='h3' className='home-h3' content={'vanpool permit requirements'} />
                                <List bulleted>
                                    <List.Item>Commute with at least two other people (three riders total).</List.Item>
                                    <List.Item>You can form your own, or visit <a href='http://rideshareonline.com' target='_blank' rel="noreferrer">Rideshare Online</a> to find potential partners.</List.Item>
                                    <List.Item>You may use a private vehicle or public transit van. If using a private vehicle, get a rideshare license plate from the <a href='https://www.dol.wa.gov' target='_blank' rel='noreferrer' title='View Washington State Department of Licensing'>Washington State Department of Licensing</a> All vanpools must have rideshare plates. Private vanpools cannot use another non-rideshare vehicle.</List.Item>
                                    <List.Item>Use your vanpool at least three days a week for a minimum of nine months.</List.Item>
                                    
                                    <List.Item>
                                        <Button basic className='button-link-text' 
                                            onClick={() => openModal(<LoginForm />)}
                                        >
                                            Register as a vanpool
                                        </Button>
                                    </List.Item>
                                    <List.Item>Vanpool permits are non-transferable and may only be used for the registered vanpool vehicle.</List.Item>
                                    <List.Item>Pay $20 annually for the permit.</List.Item>
                                </List>
                            </Container>
                        </Grid.Column>
                        <Grid.Column computer={4} tablet={4} mobile={16}>
                            <HomeSideBar />
                        </Grid.Column>
                    </Grid>
                </Segment>
            </Container>
            <Footer />
        </>
    )
})